import { ComponentProps } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { mergeClasses } from '@/utils';

const Label = ({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) => {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={mergeClasses(
        'flex items-center gap-2 text-neutral-n9 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
};

export default Label;
